import script from "./EyesightDeclarationFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./EyesightDeclarationFormView.vue?vue&type=script&setup=true&lang=js"

import "./EyesightDeclarationFormView.vue?vue&type=style&index=0&id=7486e0b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7486e0b3"]])

export default __exports__